/**
 * The mark: the head of a Eurasian hoopoe (Upupa epops) — "ibibik" is the bird's
 * Turkish name. Two features carry the whole identity: the fanned crest and the
 * long down-curved bill. Everything else is thrown away.
 *
 * Filled rather than stroked. Organic silhouettes hold together far better than
 * outlines when the artwork is a few pixels tall, and a favicon is the size that
 * actually constrains this design.
 *
 * There are deliberately two artworks. This one has three crest notches, a fine
 * bill and a small eye. `web/public/favicon-small.svg` is the same bird with two
 * broad crest bumps, a bill about twice as thick and a bigger eye — it is what
 * goes into the 16px and 32px .ico entries, where the detailed bill degrades to
 * a hairline. Same creature, fewer facts.
 */
const HOOPOE_PATH =
  'M6.9,11.2 C5.5,8.8 5.7,5.8 6.9,3.8 L8.3,7.8 L9.7,3.0 L11.1,7.6 L12.7,3.6 ' +
  'C14.7,6.0 15.3,8.8 15.0,11.0 C15.6,11.5 16.0,12.1 16.2,12.8 ' +
  'C19.3,13.2 21.9,15.1 23.5,18.0 C21.5,16.4 18.9,15.4 16.5,15.2 ' +
  'C16.0,17.3 14.2,18.8 11.9,19.2 C9.5,19.6 7.6,18.4 7.0,16.5 ' +
  'C6.4,14.8 6.4,12.7 6.9,11.2 Z M12.7,13.0 a1.0,1.0 0 1,0 0.01,0 Z'

export function Mark({ className = 'size-6' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      {/* evenodd punches the eye out of the silhouette, so the mark stays a
          single path and works in any colour without a second fill. */}
      <path d={HOOPOE_PATH} fill="currentColor" fillRule="evenodd" />
    </svg>
  )
}

/** Mark plus wordmark, as used in the page header. */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <Mark className="size-6 text-brand-600 dark:text-brand-400" />
      <span className="text-sm font-semibold tracking-tight lowercase">ibibik</span>
    </span>
  )
}
